import { render, staticRenderFns } from "./Project5.vue?vue&type=template&id=1f4ad6ee"
import script from "./Project5.vue?vue&type=script&lang=js"
export * from "./Project5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports